import _ from 'lodash';
import validator from 'validator';
import { ForbiddenEmailDomainRegExps } from '../define/consts/forbidden_email_domains';
import { isEmpty, isNullOrUndefinedOrEmpty } from '../helpers/common';
/**
 * フォーム内の入力値からFileオブジェクトを取得する
 * @deprecated TS化済 src/utils/validate/conditions/file.ts
 * @param values
 * @returns {null}
 */
const getFileFromValues = (values) => {
    let value = null;
    if (values instanceof File) {
        value = values;
    }
    else if (values) {
        value = typeof values.item === 'function' ? values.item(0) : null;
    }
    return value;
};
export const getSiblingValueByTargets = (name, record, target) => {
    const targets = Array.isArray(target) ? target : [target];
    let targetValue = '';
    targets.forEach((findTarget) => {
        if (!isEmpty(targetValue)) {
            return;
        }
        const names = name.split('.');
        names.pop();
        names.push(findTarget);
        const objTarget = names
            .join('.')
            .replace(/\[(\d+)]/, (__, group1) => `.${group1}`);
        targetValue = _.get(record, objTarget);
    });
    return targetValue;
};
/**
 * 必須チェック
 * @param value
 * @returns {string}
 */
export const isRequired = (value) => {
    const msg = '必須です。';
    const validateList = [
        (v) => v === null || v === undefined,
        (v) => Array.isArray(v) && v.length === 0,
        (v) => typeof v === 'object' && v.length === 0,
        (v) => typeof v === 'string' && v.trim().length === 0,
    ];
    return validateList.some((func) => func(value)) ? msg : '';
};
/**
 * 必須チェック＋テキスト指定
 * @deprecated TS化済 src/utils/validate/conditions/isRequired.ts
 * @param text
 * @returns {function(*=): string}
 */
export const isRequiredText = (text) => (value) => isRequired(value) ? text : '';
/**
 * 指定項目が存在する場合にテキスト指定の必須チェック
 * @param text
 * @param target
 * @returns {Function}
 */
export const isRequiredWithObj = (text, target) => (value, record, formProp, name) => {
    const targetValue = getSiblingValueByTargets(name, record, target);
    if (isEmpty(value) && !isEmpty(targetValue)) {
        return text;
    }
    return '';
};
/**
 * 指定項目が指定の値の場合のテキスト指定の必須チェック
 * @param text
 * @param target
 * @param equal
 * @returns {function(*=, *=, *, *): (*|string)}
 */
export const isRequiredWithObjEqual = (text, target, equal) => (value, record, formProp, name) => {
    const targetValue = getSiblingValueByTargets(name, record, target);
    if (isEmpty(value) && targetValue === equal) {
        return text;
    }
    return '';
};
/**
 * 指定されたキーが特定の値と一致しない場合に、バリデーションを行う
 * @param validateFunc
 * @param key
 * @param keyValue
 * @returns {function(*=, *=, *, *): (*|string)}
 */
export const isValidateIfNot = (validateFunc, key, keyValue) => (value, record, props) => record[key] !== keyValue ? validateFunc(value, record, props) : '';
/**
 * 文字列の最大チェック
 * @deprecated TS化済 src/utils/validate/conditions/strLength.ts
 * @param num
 * @param text
 * @returns {Function}
 */
export const strMax = (num, text) => (value) => {
    if (typeof value === 'string' && value.length > num) {
        return text;
    }
    return '';
};
/**
 * 文字列の最小チェック
 * @deprecated TS化済 src/utils/validate/conditions/strLength.ts
 * @param num
 * @param text
 * @returns {Function}
 */
export const strMin = (num, text) => (value) => {
    if (typeof value === 'string' && value.length > 0 && value.length < num) {
        return text;
    }
    return '';
};
/**
 * カタカナのチェック
 * @param text
 * @returns {Function}
 */
export const isKana = (text) => (value) => {
    if (typeof value === 'string' && value.length > 0) {
        return value.match(/^[ァ-ヶー]*$/) ? '' : text;
    }
    return '';
};
/**
 * 文字列の桁数チェック
 * @param num
 * @param text
 * @returns {Function}
 */
export const digits = (num, text) => (value) => {
    if (typeof value === 'string' && value.length > 0 && value.length !== num) {
        return text;
    }
    return '';
};
/**
 * 指定の列の値より大きい
 * @param target
 * @param text
 * @returns {Function}
 */
export const moreThan = (target, text) => (value, record) => {
    if (value > record[target]) {
        return '';
    }
    return text;
};
/**
 * 値が範囲内にある
 * @deprecated TS化済 src/utils/validate/conditions/number.ts
 * @param min
 * @param max
 * @param text
 * @returns {Function}
 */
export const isNumberWithinRange = (min, max, text) => (value) => {
    if (isEmpty(value)) {
        return '';
    }
    const numValue = parseInt(value, 10);
    const isGreaterThanOrEqualToMin = numValue >= min;
    const isLessThanOrEqualToMax = numValue <= max;
    return isGreaterThanOrEqualToMin && isLessThanOrEqualToMax ? '' : text;
};
/**
 * 値がそれ以上かどうか
 * @param min
 * @param text
 * @returns {Function}
 */
export const isMoreThan = (min, text) => (value) => {
    if (isEmpty(value)) {
        return '';
    }
    const numValue = parseInt(value, 10);
    const isGreaterOrEqualToMin = numValue >= min;
    return isGreaterOrEqualToMin ? '' : text;
};
/**
 * 値がそれより大きいかどうか
 * @deprecated TS化済 src/utils/validate/conditions/number.ts
 * @param min
 * @param text
 * @returns {Function}
 */
export const isMore = (min, text) => (value) => {
    if (isEmpty(value)) {
        return '';
    }
    const numValue = parseInt(value, 10);
    const isGreaterOrEqualToMin = numValue > min;
    return isGreaterOrEqualToMin ? '' : text;
};
/**
 * 値がそれより大きいかどうか(フロート版)
 * @param min
 * @param text
 * @returns {function(...[*]=)}
 */
export const isMoreFloat = (min, text) => (value) => {
    if (isEmpty(value)) {
        return '';
    }
    const numValue = parseFloat(value);
    const isGreaterOrEqualToMin = numValue > min;
    return isGreaterOrEqualToMin ? '' : text;
};
/**
 * Eメールアドレスチェック
 * @deprecated TS化済 src/utils/validate/conditions/email.ts
 * @param text
 * @returns {function(*=): string}
 */
export const isEmail = (text) => (value) => validator.isEmail(value) ? '' : text;
/**
 * Eメールアドレスチェック（空文字許可）
 * @param text
 * @returns {function(*=): string}
 */
export const isNullableEmail = (text) => (value) => {
    if (!value) {
        return '';
    }
    return validator.isEmail(value) ? '' : text;
};
/**
 * Eメールアドレスのドメインチェック
 * @deprecated TS化済 src/utils/validate/conditions/email.ts
 * @param text
 * @returns {function(*): string}
 */
export const isAllowedEmailDomain = (text) => (value) => !ForbiddenEmailDomainRegExps.find((re) => value.match(re)) ? '' : text;
/**
 * Eメールアドレスのドメインチェック（空文字許可）
 * @param text
 * @returns {function(*): string}
 */
export const isNullableAllowedEmailDomain = (text) => (value) => {
    if (!value) {
        return '';
    }
    return !ForbiddenEmailDomainRegExps.find((re) => value.match(re)) ? '' : text;
};
/**
 * Eメールアドレスのドメインチェック（含まない）
 * @param domains
 * @param text
 * @returns {function(*): string|*}
 */
export const isIncludedEmailDomain = (domains, text) => (value) => {
    const domain = value.split('@')[1];
    return !domains.includes(domain) ? '' : text;
};
/**
 * Eメールアドレスのドメインチェック（含む）
 * @param domains
 * @param text
 * @returns {function(*): string|*}
 */
export const isNotIncludedEmailDomain = (domains, text) => (value) => {
    const domain = value.split('@')[1];
    return domains.includes(domain) ? '' : text;
};
/**
 * 数値判定
 * @param text
 * @returns {function(*=): string}
 */
export const isNumber = (text) => (value) => {
    const num = Math.round(value);
    if (!isNullOrUndefinedOrEmpty(value) && Number.isNaN(num)) {
        return text;
    }
    return '';
};
/**
 * パスワードが半角英数記号を1文字ずつ含むかチェック
 * @deprecated TS化済 src/utils/validate/conditions/password.ts
 * @param text
 * @returns {function(*=): string}
 */
export const isValidFormatPassword = (text) => (value) => {
    // 先頭・末尾にスペースがある場合はNG（Cognito対応）
    if (typeof value === 'string' && value !== value.trim()) {
        return text;
    }
    const hasAlphabet = /[a-zA-Z]/i.test(value);
    const hasNumber = /\d/.test(value);
    const hasSymbol = /[!"#$%&'()*+\-.,/:;<=>?@[\\\]^_`{|}~]/g.test(value);
    if (!isNullOrUndefinedOrEmpty(value) &&
        !(hasAlphabet && hasNumber && hasSymbol)) {
        return text;
    }
    return '';
};
/**
 * 整数判定
 * @deprecated TS化済 src/utils/validate/conditions/number.ts
 * @param text
 * @returns {function(*=): string}
 */
export const isInteger = (text) => (value) => {
    const isEmptyValue = isNullOrUndefinedOrEmpty(value);
    const matchResult = !isEmptyValue && String(value).match(/^\d+$/);
    if (!isEmptyValue && !matchResult) {
        return text;
    }
    return '';
};
/**
 * URL判定
 * @param text
 * @returns {function(*=): string}
 */
export const isUrl = (text) => (value) => {
    if (isNullOrUndefinedOrEmpty(value) || validator.isURL(value)) {
        return '';
    }
    return text;
};
/**
 * 正常なファイルがアップロードされているか
 * @deprecated src/utils/validate/conditions/file.ts
 * @param emptyText
 * @returns {Function}
 */
export const isFileValid = (emptyText) => (values) => {
    const value = getFileFromValues(values);
    if (!value) {
        return '';
    }
    if (value.size > 0) {
        return '';
    }
    return emptyText || '空のファイルが指定されています';
};
/**
 * 指定のファイル種別のファイルでアップロードされているか
 * @deprecated src/utils/validate/conditions/file.ts
 * @param acceptType
 * @param text
 * @returns {Function}
 */
export const isAllowAcceptTypeFile = (acceptType, text) => (values) => {
    const value = getFileFromValues(values);
    if (!value) {
        return '';
    }
    const typeList = acceptType.split('/');
    const valueTypeList = value.type.split('/');
    const checkValues = [
        {
            allowValue: typeList[0],
            checkValue: valueTypeList[0],
        },
        {
            allowValue: typeList[1],
            checkValue: valueTypeList[1],
        },
    ];
    const checked = checkValues.every(({ allowValue, checkValue }) => allowValue === '*' || allowValue === checkValue);
    if (checked) {
        return '';
    }
    return text;
};
/**
 * 指定のMBサイズ以下のファイルが選択されているか
 * @deprecated src/utils/validate/conditions/file.ts
 * @param allowMegaSize
 * @param text
 * @returns {Function}
 */
export const isAllowMegaSizeFile = (allowMegaSize, text) => (values) => {
    if (!values) {
        return '';
    }
    const value = getFileFromValues(values);
    if (!value) {
        return '';
    }
    if (value && allowMegaSize * 1024 * 1024 >= value.size) {
        return '';
    }
    return text;
};
/**
 * arrayを所持しているかどうか
 * @deprecated src/utils/validate/conditions/array.ts
 * @param text
 * @returns {function(...[*]=)}
 */
export const isHasArray = (text) => (values) => {
    if (Array.isArray(values) && values.length > 0) {
        return '';
    }
    return text;
};
/**
 * 画像ファイルかどうかの判定
 * @param text
 * @returns {function(...[*]=)}
 */
export const isImageFile = (text) => (value) => {
    if (value && value instanceof File) {
        const match = value.name.match(/\.([^.]+)$/);
        const rawExt = (match && match && match.length === 2 && match[1]) || '';
        const ext = rawExt.toLowerCase();
        const allowExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
        return allowExtensions.includes(ext) ? '' : text;
    }
    return '';
};
/**
 * 関数によるバリデーション
 * @param validates
 * @returns {function(*=, *=, *=): string}
 */
export const functionalValidate = (validates = []) => (value, record, props) => {
    let result = '';
    validates.forEach((func) => {
        if (!result) {
            result = func(value, record, props);
        }
    });
    return result;
};
